// SSE Connection Debugger Utility
export const debugSSEConnection = (userInfo, blogId) => {
    // Silent validation for production
    if (!userInfo?.unique_id) {
        return false;
    }

    if (!blogId) {
        return false;
    }

    return true;
};

export const logSSEEvent = (eventType, data) => {
    // Silent logging for production
    return;
};

export const logGenerationStart = (contentType, payload) => {
    // Silent logging for production
    return;
};

export const logGenerationError = (contentType, error) => {
    // Silent logging for production
    return;
};